import { sentenceCase } from 'change-case';
import { valueToEnumOrNull } from 'common/EnumUtils';
import { find } from 'lodash';
import {
  CuisineCategory,
  CuisineCategoryType,
  CuisineSearchResultFieldsFragment,
  HierarchicalAvailableCuisineCategoryFragment,
} from 'src/gqlReactTypings.generated.d';
import { dietaryTagToImgSrc } from 'src/shared/utils/IconUtils';
import { SegmentDisplayInfo, SegmentFilterDisplayInfo } from 'src/shared/utils/SegmentFilterUtils';
import { DietaryTags } from 'web-common/src/shared/Enums';

function maybeGetDietaryDisplayInfo(
  id: HierarchicalAvailableCuisineCategoryFragment['id'],
  type?: CuisineSearchResultFieldsFragment['category']['type']
) {
  if (type !== CuisineCategoryType.Dietary) {
    return null;
  }
  const dietaryTag = valueToEnumOrNull(DietaryTags, sentenceCase(id));
  return dietaryTag
    ? {
        icon: dietaryTagToImgSrc[dietaryTag],
        hoverIcon: dietaryTagToImgSrc[dietaryTag],
        title: id,
      }
    : null;
}

export const pickSubcuisineIcon = ({
  id,
  type,
  ancestorCuisines,
}: {
  id: CuisineCategory['id'];
  type?: CuisineCategory['type'];
  ancestorCuisines: Pick<CuisineCategory, 'isPrimary' | 'id'>[];
}): SegmentDisplayInfo => {
  const dietaryDisplayInfo = maybeGetDietaryDisplayInfo(id, type);
  const primaryAncestor = find(ancestorCuisines, 'isPrimary');
  return (
    dietaryDisplayInfo ??
    SegmentFilterDisplayInfo[id] ??
    (primaryAncestor && SegmentFilterDisplayInfo[primaryAncestor.id]) ??
    SegmentFilterDisplayInfo.MORE
  );
};
